module.exports = __webpack_public_path__ + "static/031.thumb-27342d42b3b440fba4ba402a374168e3.jpg";